// 公共配置接口地址
const base = {
    // 客户端
    // addKhUser:'/zcqh_wxapplet/client/openAccountSubscribe/add',    // 新增意向开户客户
    getPicCode: '/zcqh_wxapplet/index/getPicCodeImage',            // 获取图片验证码
    // addNew: '/zcqh_wxapplet/client/openAccountSubscribe/addnew',    // 开户预约(需要验证码)
    add: '/zcqh_wxapplet/client/openAccountSubscribe/add'           // 开户预约(手机号AES加密)

    // getPicCode: '/api/zcqh_wxapplet/index/getPicCodeImage',            // 获取图片验证码
    // addNew: '/api/zcqh_wxapplet/client/openAccountSubscribe/addnew',    // 开户预约(需要验证码)
    // add: '/api/zcqh_wxapplet/client/openAccountSubscribe/add'           // 开户预约(手机号AES加密)


}

export default base